import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Container from "./container";


const st = [];
class Chat extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [props.statements[0]],
            chatBoxSize: 0
        };
        props.chatDataSetter([props.statements[0]]);
        // setTimeout(() => {
        //     this.setState({
        //         data: [...this.state.data, props.questions[0]]
        //     }, () => {
        //         props.chatDataSetter(this.state.data);
        //     })
        // }, props.statements[0].text.length * 80 + 1000);
    }

    componentDidMount() {
        const node = ReactDOM.findDOMNode(this.chatBox);
        if (node) {
            let rect = node.getBoundingClientRect();
            let elemBottom = rect.bottom;
            this.setState({
                chatBoxSize: elemBottom
            })
        }
    }
    setTheState(next) {

        this.setState({
            data: [...this.state.data, next]
        }, () => {
            this.props.chatDataSetter(this.state.data);
        });

    }

    setTutorialCompleteFlag = () => {
        this.props.setEndTutorialPopup(true)
    }


    setChatCompleted = () => {
        if (this.props.tutorial.isRunning) {
            this.props.stopTutorial();
            this.props.chatCompleted();
            setTimeout(() => {
                this.props.startTutorial();
                this.setTutorialCompleteFlag()
            }, 4000);
        } else {
            setTimeout(() => {
                this.props.chatCompleted();
            }, 1000);
        }
    }
    triigerTheStatement = (nextStatement) => {
        if (nextStatement) {
            this.setTheState(nextStatement);
        }
    }

    afterStatementEnds = () => {
        const { questions, statements } = this.props;
        const recentStatement = this.state.data[this.state.data.length - 1]
        // if next is a question
        if (recentStatement.questionId) {
            const nextQuestion = questions.find((qsn) => qsn.id === recentStatement.questionId);
            if (nextQuestion) {
                setTimeout(() => {
                    this.setTheState(nextQuestion);
                }, 1000)
            }
        }
        // if next is a statemnt
        if (recentStatement.statementId) {
            const nextStatementInFut = statements.find((qsn) => qsn.id === recentStatement.statementId);
            if (nextStatementInFut) {
                this.triigerTheStatement(nextStatementInFut);
            }
        }
        if (!recentStatement.questionId && !recentStatement.statementId) {
            // end 
            this.setChatCompleted()
        }
    }
    userClickedOnSubmit = (questionId, optionId) => {
        const { questions, statements } = this.props;
        if (!optionId) {
            return;

        }
        const newState = this.state.data.map((ele) => {
            if (ele.type === "mcq" && ele.id === questionId) {
                return {
                    ...ele,
                    userOptionId: optionId
                };
            }
            return {
                ...ele
            };
        });
        this.setState({
            data: [...newState]
        }, () => {
            this.props.chatDataSetter(this.state.data);
            const nextStatementId = this.state.data.find((qsn) => {
                return qsn.type == "mcq" && qsn.id === questionId
            }).options.find((option) => {
                return option.id === optionId
            }).nextStatementId;

            const nextStatement = statements.find((s) => s.id === nextStatementId);
            if (nextStatement) {
                this.triigerTheStatement(nextStatement);
            } else {
                this.setChatCompleted()
            }
        });
    }

    getTheNextStatementForTheAnswer = () => {

    }

    render() {
        if (!this.state) {
            return <div />;
        }
        return (
            <div
                style={this.props.width ? { maxWidth: '880px', marginTop: '-40px', height: '60%' } : { maxWidth: '880px', marginTop: '-40px', height: '100%' }}
                ref={(el) => {
                    this.chatBox = el;
                }}>
                <Container chats={this.state.data} userClickedOnSubmit={this.userClickedOnSubmit} selfActor={this.props.selfActor} chatContainerHeight={this.props.chatContainerHeight} selfActorImage={this.props.selfActorImage}
                    actors={this.props.actors} width={this.props.width} chatBoxSize={this.state.chatBoxSize} afterStatementEnds={this.afterStatementEnds}
                    //For tutorial
                    tutorial={this.props.tutorial}
                    startTutorial={this.props.startTutorial}
                    stopTutorial={this.props.stopTutorial}
                    addStepsToTutorial={this.props.addStepsToTutorial}
                    updateStepNumber={this.props.updateStepNumber}
                />
            </div>
        );
    }
}

export default Chat;



// WEBPACK FOOTER //
// /src/call/container/chat.js